import { createFileRoute, redirect } from '@tanstack/react-router'
import KitchenDashboard from '@/pages/KitchenDashboard'

export const Route = createFileRoute('/staff-kitchen')({
  component: KitchenDashboard,
  beforeLoad: () => {
    // Check if staff is authenticated
    const staffAuth = localStorage.getItem('digimataam_staff_auth')
    const restaurantId = localStorage.getItem('digimataam_staff_restaurant')

    // Determine redirect URL - use staff login if restaurant ID is stored
    const redirectUrl = restaurantId ? `/staff-login?restaurant=${restaurantId}` : '/'

    if (!staffAuth) {
      throw redirect({ to: redirectUrl })
    }

    try {
      const staff = JSON.parse(staffAuth)
      if (staff.role !== 'kitchen') {
        throw redirect({ to: redirectUrl })
      }
    } catch {
      localStorage.removeItem('digimataam_staff_auth')
      throw redirect({ to: redirectUrl })
    }
  },
})
